import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useWebSocket } from '../hooks/useWebSocket';

export default function WSListener() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { pathname } = useLocation();

  const token = localStorage.getItem('accessToken') || '';
  const tenantId = localStorage.getItem('tenantId') || '';

  useEffect(() => {
    const bc = new BroadcastChannel('ws-events');
    return () => bc.close();
  }, []);

  const onEvent = useCallback((event, data) => {
    console.log('[WS EVENT]', event, data);

    // Propaga a tutte le tab
    const bc = new BroadcastChannel('ws-events');
    bc.postMessage({ event, data });
    bc.close();

    // Qui puoi anche dispatch Redux / toast / invalidate react-query
  }, []);

  const enabled =
    isAuthenticated &&
    !!token &&
    !!tenantId &&
    pathname !== '/login';

  useWebSocket({
    enabled,
    token,
    tenantId,
    onEvent,
  });

  return null;
}